import { render, staticRenderFns } from "./CollectedMerchandise.vue?vue&type=template&id=08f1d534&scoped=true"
import script from "./CollectedMerchandise.vue?vue&type=script&lang=js"
export * from "./CollectedMerchandise.vue?vue&type=script&lang=js"
import style0 from "./CollectedMerchandise.vue?vue&type=style&index=0&id=08f1d534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1d534",
  null
  
)

export default component.exports